import { Provider } from '@angular/core';
import { PERSISTED_SLICES, PersistedSlice } from '../../oidc/store/persisted-state';
import * as pushNotificationFeature from './push-notification.reducer';

export const providePushNotificationPersistence = (): Provider => ({
  provide: PERSISTED_SLICES,
  multi: true,
  useValue: {
    name: pushNotificationFeature.name,
    reshape: (stored: unknown): pushNotificationFeature.PushNotificationState => {
      if(stored === null) {
        return pushNotificationFeature.initialState;
      }
      return stored as pushNotificationFeature.PushNotificationState;
    },
  } satisfies PersistedSlice<pushNotificationFeature.PushNotificationState>,
});
